import React, { useState , useEffect} from 'react'
import HeadingArea from '../../general/HeadingArea'
import { RiDeleteBin6Line } from 'react-icons/ri';
import { MdOutlineEdit } from 'react-icons/md';
import axios from 'axios'
import ResponseMsg2 from '../../general/ResponseMsg2'
import { FaCheck } from 'react-icons/fa';


const VehicleRoutes = ({setLoading}) => {

  const [route, setRoute] = useState([]);
   const [response2, setResponse2] = useState({ message: '', status: 'success' });

   const [selectedRoute,setSelectRoute]= useState('');

  const [formData, setformData] = useState({
    title: '',
    fare: '',
    vehicle_id:''
  })

  // search filter
  const [searchFilter, setSearchFilter] = useState('');
  const [showDelete, setShowDelete]  = useState(false);


  const filteredData = route.filter((r) =>{
    const term = searchFilter.toLowerCase();
    return (
 r.title.toLowerCase().includes(term) ||
    r.fare.toLowerCase().includes(term)
    )
  });


  const handleChange = (e) => {
    setformData({
      ...formData,
      [e.target.name]: e.target.value
    });
  }
  

    const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const res = await axios.post(
        "https://api.kcian.in/add-route",
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
       setResponse2({ message:  'Route Added Successfully.', status: 'success' });
       fetchVehicleRoute();   
    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
    } finally {
      setLoading(false);
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };

        const fetchVehicleRoute = async () => {
            try {
                const res = await axios.get('https://api.kcian.in/fetch-vehicle-route');
                setRoute(res.data);

            } catch (error) {
                console.log(error)
            }
        };


 useEffect(() => {
        fetchVehicleRoute();
    }, []);


    const handleDelete = async (id) => {
      setLoading(true);

      try {
            const res = await axios.delete(`https://api.kcian.in/delete-route/${id}`);
         setShowDelete(false);
         setResponse2({ message: 'Route Deleted Successfully!', status: 'success' });
         fetchVehicleRoute();
        } catch (err) {
            console.error(err.response?.data || err.message);
                            // setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        } finally {
                setLoading(false);
                  setTimeout(() => {
          setResponse2('');
        }, 3000);
        }
    };

  
    const handleShowDelete = (item) => {
    setSelectRoute(item);
    setShowDelete(true);
  }

  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Transport' message2='Routes' />
           {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
          <div className='row'>

            <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>

              <div className="profile-card">
                <p className="profile-heading">Add Route</p>
                <form className='mt-4' onSubmit={handleSubmit}>
                    {/* Route Title */}
                    <div className="profile-input-area mb-4">
                      <label className="profile-badge">Route Title*</label>
                      <input
                        type="text"
                        name="title"
                        className="profile-input"
                        value={formData.title}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    {/* Fare */}
                    <div className="profile-input-area mb-4">
                      <label className="profile-badge">Fare*</label>
                      <input
                        type="text"
                        name="fare"
                        className="profile-input"
                        value={formData.fare}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  {/* SAVE */}
                  <div className='text-center'>
                    <button type='submit' className='profile-btn'><FaCheck /> SAVE</button>
                  </div>
                </form>
              </div>
            </div>
            {/* table-section */}
            <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
              <div className='profile-card'>

                <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                  <span className="profile-heading align-content-center">Route List</span>

                  <div className='profile-input-area ms-auto col-lg-3 border-0'>
                    <input
                      type='text'
                      name='search'
                      className='profile-input border-bottom rounded-0'
                      placeholder='Search...'
                      value={searchFilter}
                      onChange={(e) => setSearchFilter(e.target.value)}
                    />
                  </div>
                </div>

                <div className='table-responsive'>
                  <table className='w-100 text-center'>

                    <thead className='account-thead'>
                      <tr>
                        <th className='rounded-start-4'>S No</th>
                        <th>Route Title</th>
                        <th>Fare</th>
                        <th className='rounded-end-4'>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((itm, idx) => (
                          <tr className='account-tr' key={idx}>
                            <td>{idx + 1}</td>
                            <td>{itm.title}</td>
                            <td>{itm.fare}</td>
                            <td>
                             
                              <RiDeleteBin6Line className='account-icon1' title='Remove'
                               onClick={() => handleShowDelete(itm)} />
                            </td>
                          </tr>
                        ))
                      ) :
                        <tr>
                          <td colSpan="4" className="text-center py-3 text-muted">
                            No Data found.
                          </td>
                        </tr>
                      }

                    </tbody>
                  </table>

                  
    {showDelete && (
        <>
          <section className='ins-dialog'>
            <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

              <p className='ins-dialog-heading text-danger'>Remove This Route!</p>

              <div className='table-responsive'>
                <table className='w-100'>

                  <thead className='account-thead'>
                    <th className='rounded-start-4'>Route Title</th>
                    <th className='rounded-end-4'>Fare</th>
                  </thead>

                  <tr className='account-tr'>
                    <td>{selectedRoute.title}</td>
                    <td>{selectedRoute.fare}</td>

                  </tr>


                </table>
              </div>

              <p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Route will be permanently removed.</p>

              <button className='profile-btn me-2' onClick={() => handleDelete(selectedRoute.id)}>Remove</button>
              <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


            </div>
          </section>
        </>
      )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default VehicleRoutes